




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

type Type = 'default' | 'custom';

@Component({
  components: {
    Typography
  }
})
export default class Amount extends Vue {
  @Prop({ default: '' }) readonly label?: string;
  @Prop({ default: 0 }) readonly value!: number;
  @Prop({ default: false }) readonly isSelected?: boolean;
  @Prop({ default: 'default' }) readonly type?: Type;
  @Prop({ default: 'Custom' }) readonly customLabel?: string;
  @Prop({ default: '' }) readonly customSufix?: string;
  @Prop({ default: 0 }) readonly inputMin?: number;
  @Prop({ default: 99 }) readonly inputMax?: number;
  @Prop({ default: true }) readonly isValid?: boolean;
  @Prop({ default: '__' }) readonly placeholder?: string;

  isFocused: boolean = false;
  inputWidth: number = 20;

  get isSelectedCondition() {
    return (
      (this.type === 'custom' && this.value !== null && !this.isFocused) ||
      !!this.isSelected
    );
  }

  mounted() {
    this.updateInputWidth();
  }

  get displayText() {
    return this.value || this.placeholder || '';
  }

  updateInputWidth() {
    this.$nextTick(() => {
      const sizer = this.$refs.textSizer as HTMLElement;
      if (sizer) {
        this.inputWidth = sizer.offsetWidth;
      }
    });
  }

  handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let numericValue = Number(input.value.slice(0, 2));

    if (numericValue < (this.inputMin || 0)) {
      numericValue = this.inputMin || 0;
    } else if (numericValue > (this.inputMax || 99)) {
      numericValue = this.inputMax || 99;
    }

    input.value = numericValue.toString();
    this.$emit('input', numericValue);
    this.updateInputWidth();
  }

  handleFocus() {
    this.isFocused = true;
    this.$emit('input-state-focus', true);
  }

  handleFocusOut() {
    this.isFocused = false;
    this.$emit('input-state-focus', false);
  }

  onlyNumber(val: any) {
    if (isNaN(Number(val.key))) {
      return val.preventDefault();
    }
  }
}
